import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

export default function CourseCardSkeleton() {
  return (
    <Card className="border-0 card-shadow bg-white rounded-2xl overflow-hidden animate-pulse">
      <CardContent className="p-0">
        {/* Image skeleton */}
        <div className="w-full h-48 bg-gray-200"></div>
        
        {/* Content skeleton */}
        <div className="p-6 space-y-4">
          {/* Title */}
          <div className="h-6 bg-gray-200 rounded w-3/4"></div>
          
          {/* Progress bar */}
          <div className="space-y-2">
            <div className="flex justify-between">
              <div className="h-4 bg-gray-200 rounded w-1/4"></div>
              <div className="h-4 bg-gray-200 rounded w-1/6"></div>
            </div>
            <div className="h-2 bg-gray-200 rounded w-full"></div>
          </div>
          
          {/* Stats */}
          <div className="flex gap-4">
            <div className="h-4 bg-gray-200 rounded w-1/4"></div>
            <div className="h-4 bg-gray-200 rounded w-1/4"></div>
          </div>
          
          {/* Button */}
          <div className="h-10 bg-gray-200 rounded-xl w-full"></div>
        </div>
      </CardContent>
    </Card>
  );
}
